import { makeVar } from '@apollo/client'

export const isOfflineDialogOpenVar = makeVar(false)
export const isBetaWelcomeDialogOpenedVar = makeVar(false)
